<template lang="pug">
  .d-case
    img.top-img(src="~assets/case/04/img1.png")
    .content
      .case-num Vol.04
      .case-title 上海市区一套房，郊外一栋度假屋，生活这样真挺好！
      .line1 经济发展水平越高，越多的中产阶级会渴望返璞归真，栖居田园。
      .line1 平时工作、学习在市区，周末住郊外感受辽阔乡野，懂窝客户Josie就是这样。她把上海崇明老宅改造翻新，成了一家人周末小聚度假的胜地。
      .cont-title 认识屋主
      .line1 Josie，美丽的二娃宝妈。早年从事画廊工作，对美和艺术有独到理解与认知，喜欢研究服饰、家居搭配，游历世界各地，擅于发现美，更把美带到生活的点滴里。
      .cont-title 房子的基本信息
      .line1
        <span>坐标：上海崇明 </span>
        <span>户型：三层楼别墅</span>
        <span>装修风格：现代轻奢</span>
      img.cont-img(src="~assets/case/04/img2.png")
      .cont-title 崇明自住宅翻新，颠覆传统“乡村风”
      .line1 Josie先生是上海崇明人，这栋房子是崇明父母家的自住宅。老人家年纪大了，希望能改善下居住环境，Josie也希望在乡下给孩子们留更多玩耍的空间。于是一家人决定对老宅进行翻新。
      .line1 崇明有很多别墅，装修都比较传统，简单的白墙和装饰，在Josie看来是对空间的一种浪费。所以在装修自己家的时候，就着意颠覆传统“乡村风”。
      img.cont-img(src="~assets/case/04/img3.png")
      .line1 上下三层楼，一楼空间主要是客厅和老人卧室，二楼是Josie一家的生活空间，三楼是健身房和孩子们的娱乐室。
      .line1 房子的硬装整体以轻奢风为主，墙面和天花都用了很多石膏板、线，更不乏大理石、金线勾勒，凸显轻奢时尚的气质。
      .line1 Josie对色彩的搭配有很多自己的理解，比如一楼整体以米色、灰色为主，简约耐看。相对沉稳的配色也能迎合老人的审美偏好。
      img.cont-img(src="~assets/case/04/img1.png")
      .line1 二楼是客厅、主卧和2个儿童房。客厅墙面没有跟随近几年非常流行的复古绿，而是选用淡绿色，让空间显得更宽敞，也很跳跃有活力。
      .cont-title 三次装修，不断迭代的审美
      .line1 家具的选择迎合硬装色彩和整体轻奢的氛围。
      .line1 除了定制柜体之外，基本全数购自懂窝，除了一楼客厅的茶几略显小了以外，Josie对自己的搭配甚是满意。
      img.cont-img(src="~assets/case/04/img5.png")
      .line1 毕竟，这是经历过三次装修淬炼出的审美。
      .line1 早年第一次装修，是自己的婚房，那时候非常喜欢北欧某品牌的家具，但用久了会觉得品质稍差一些。第二次装修学区房，买了一堆黑胡桃木色的家具，但学区房空间太小，时间长了又会觉得压抑。
      .line1 崇明的别墅，比前面两套房子都要大很多，Josie的审美，也开始跃升到对品质、简约风格的追求。
      img.cont-img(src="~assets/case/04/img6.png")
      .line1 她想起初到先生家，看到陈旧过时家具的那种感受，觉得自己再怎样，也要为孩子们打造一个10年20年都仍然耐看的家居环境。
      .line1 “简约耐看的家具，同时兼具品质感，时间久了也不会觉得过时。”
      .cont-title 懂窝的家具，为空间注入灵魂
      .line1 懂窝的产品与Josie的审美不谋而合。
      .line1 一楼客厅的弗雷德里克沙发，线条简约利落，米白色优雅耐看。意大利头层牛皮，高贵的品质感与绰约的空间气质非常吻合。
      img.cont-img(src="~assets/case/04/img7.png")
      .line1 一盏艾尔弗雷德地灯，搭配在沙发边，轻巧精致，幽静的夜晚，像一轮圆月点缀角落。
      .line1 坎普顿边几可以置物收纳，把零碎物件“藏”起来，是Josie所秉承的家居美学理念：把杂物收起来，外观尽可能赏心悦目，随着时间推移，目之所及的地方还可以摆上更多喜欢的物件。
      img.cont-img(src="~assets/case/04/img8.png")
      .line1 主卧带阳台，马利克斯双人床与床头柜，进口楸木实木气质温暖。
      img.cont-img(src="~assets/case/04/img9.png")
      .line1 书房也是Josie使用频率很高的地方，胡桃木色莱拉书桌与欧文台灯在丝绒窗帘映衬下，营造出一处静谧的读书角。
      img.cont-img(src="~assets/case/04/img10.png")
      .line1 三楼是一家人的活动空间兼衣帽间，练瑜伽、跑步，小孩玩耍，都有足够的空间。福斯抽象画摆在一角，运动完了可以坐下赏画静思，在这样一个空间里放空身心，是Josie在国外游历所习得的生活方式。
      .line1 在这栋度假屋里，荡涤工作日在城市里沾染的喧嚣，吐纳一方悠然与静谧，这样的家，大概也是很多人的梦想吧。
      img.cont-img(src="~assets/case/04/img11.png")
      .cont-title1  Q&A
      .line2 <span>Q：整个装修花了多少预算？</span>A：硬装是找朋友做的，其实没花太多，大概30万左右，家具软装这些50多万，加上老房拆改工程、电器等，100万左右吧。
      .line2 <span>Q：为什么想花这么多预算或精力来装修这套房子？</span>A：平时工作、上学住在上海市区，生活其实挺累的，孩子们周末也没太多地方去玩，加上长辈们也想改善下居住环境，就把房子彻底翻新改造一下，这样大家都会住得非常舒服。一个小时的车程也不会太远，一家人也可以经常团聚。
      .line2 <span>Q：你对装修或色彩搭配这块有什么个人偏好吗？</span>A：其实我是一个颜值控，喜欢有设计感、美的东西，然后对这些也比较挑剔。从家具搭配风格看，我比较偏向简约耐看的，因为家具要用10年、20年，它应该是品质上经久耐用的，设计上又不易过时的。同时色彩可以亮一些，这样会让氛围更加跳跃，也比较温馨。
      .line2 <span>Q：为什么选购懂窝的产品？</span>A：我家除了一些柜体，基本上的成品家具都在懂窝买的。还是比较符合我个人审美吧，包括品质细节这些都不错，比如床头柜里面还有一层绒布，很精致。
    img.scroll-top-btn(v-show="scrollTop", @click="backtop", src="~assets/goTop.png")
</template>

<script>
export default {
  data() {
    return {
      scrollTop: false
    }
  },
  mounted () {
    window.addEventListener("scroll", this.showbtn, true);
  },
  methods: {
    // 显示回到顶部按钮
    showbtn() {
      let that = this;
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      that.scrollTop = scrollTop;
    },
    /**
     * 回到顶部功能实现过程：
     * 1. 获取页面当前距离顶部的滚动距离（虽然IE不常用了，但还是需要考虑一下兼容性的）
     * 2. 计算出每次向上移动的距离，用负的滚动距离除以5，因为滚动的距离是一个正数，想向上移动就是做一个减法
     * 3. 用当前距离加上计算出的距离，然后赋值给当前距离，就可以达到向上移动的效果
     * 4. 最后记得在移动到顶部时，清除定时器
     */
    backtop() {
      var timer = setInterval(function() {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 30);
    }
  }
};
</script>

<style lang="sass" scoped>
@import 'config'
.d-case
  width: 100%
  position: relative
  padding-top: 0.1px
  .top-img
    width: 100%
    position: absolute
    z-index: -1
  .content
    margin: r(869) auto 0
    width: r(1020)
    // height: r(300)
    background: #ffffff
    padding-top: 0.1px
    padding-bottom: r(350)
    .case-num
      margin: r(43) auto
      width: r(844)
      font-family: PingFangSC-Regular
      font-size: r(20)
      color: #717273
      letter-spacing: 0
    .case-title
      margin: r(18) auto r(50)
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(40)
      color: #070809
      line-height: r(60)
    .line1
      margin: r(30) auto
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #585858
      line-height: r(34)
      span
        display: block
        text-align: center
    .cont-img
      margin-top: r(60)
      width: 100%
    .cont-title
      margin-top: r(64)
      font-weight: bolder
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
    .cont-title1
      margin-top: r(100)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      text-align: center
    .line2
      margin: r(31) auto 0
      width: r(844)
      font-family: PingFangSC-Medium
      font-size: r(20)
      color: #070809
      line-height: r(34)
      span
        display: block
        color: #000000
  .scroll-top-btn
    position: fixed
    z-index: 100
    bottom: r(100)
    right: r(100)
    width: r(80)
</style>



// WEBPACK FOOTER //
// case4.vue?7b040a61